import { Navigate, RouteObject } from "react-router";
import { CommitmentsRoute } from "@/routes/processes/[processId]/vbs/commitments/commitments-route";
import { CommitmentRoute } from "@/routes/processes/[processId]/vbs/commitments/[commitmentId]/commitment-route";
import { TreatmentRoute } from "@/routes/processes/[processId]/vbs/commitments/[commitmentId]/treatment/treatment-route";
import { PricingRoute } from "@/routes/processes/[processId]/vbs/commitments/[commitmentId]/pricing/pricing-route";
import { CalculationRoute } from "@/routes/processes/[processId]/vbs/commitments/[commitmentId]/calculation/calculation-route";
import { DataRoute } from "@/routes/processes/[processId]/vbs/commitments/[commitmentId]/data/data-route";

export const commitmentsRoutes: RouteObject[] = [
  {
    index: true,
    element: <CommitmentsRoute />,
  },
  {
    path: ":relationshipId/:commitmentId",
    element: <CommitmentRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <DataRoute />,
      },
      {
        path: "pricing",
        element: <PricingRoute />,
      },
      {
        path: "calculation",
        element: <CalculationRoute />,
      },
      {
        path: "treatment",
        element: <TreatmentRoute />,
      },
    ],
  },
];
